import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import Locales from './Locales';
import ClientProvider from './client';
export default createDemo(import.meta.url, Locales, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/guides/localization/demos/locales/Locales.tsx",
    "fileName": "Locales.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport TablePagination from '@mui/material/TablePagination';\nimport Autocomplete from '@mui/material/Autocomplete';\nimport Box from '@mui/material/Box';\nimport TextField from '@mui/material/TextField';\nimport { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';\nimport * as locales from '@mui/material/locale';\n\ntype SupportedLocales = keyof typeof locales;\n\nexport default function Locales() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [locale, setLocale] = React.useState<SupportedLocales>('zhCN');\n\n  const theme = useTheme();\n\n  const themeWithLocale = React.useMemo(\n    () => createTheme(theme, locales[locale]),\n    [locale, theme],\n  );\n\n  return (\n    <Box sx={{ width: '100%' }}>\n      <ThemeProvider theme={themeWithLocale}>\n        <Autocomplete\n          options={Object.keys(locales)}\n          getOptionLabel={(key) => `${key.substring(0, 2)}-${key.substring(2, 4)}`}\n          style={{ width: 300 }}\n          value={locale}\n          disableClearable\n          onChange={(event: any, newValue: string | null) => {\n            setLocale(newValue as SupportedLocales);\n          }}\n          renderInput={(params) => (\n            <TextField {...params} label=\"Locale\" fullWidth />\n          )}\n        />\n        <TablePagination\n          count={2000}\n          rowsPerPage={10}\n          page={1}\n          component=\"div\"\n          onPageChange={() => {}}\n        />\n      </ThemeProvider>\n    </Box>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 47,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport TablePagination from '@mui/material/TablePagination';\nimport Autocomplete from '@mui/material/Autocomplete';\nimport Box from '@mui/material/Box';\nimport TextField from '@mui/material/TextField';\nimport { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';\nimport * as locales from '@mui/material/locale';\n\ntype SupportedLocales = keyof typeof locales;\n\nexport default function Locales() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [locale, setLocale] = React.useState<SupportedLocales>('zhCN');\n\n  const theme = useTheme();\n\n  const themeWithLocale = React.useMemo(\n    () => createTheme(theme, locales[locale]),\n    [locale, theme],\n  );\n\n  return (\n    <Box sx={{ width: '100%' }}>\n      <ThemeProvider theme={themeWithLocale}>\n        <Autocomplete\n          options={Object.keys(locales)}\n          getOptionLabel={(key) => `${key.substring(0, 2)}-${key.substring(2, 4)}`}\n          style={{ width: 300 }}\n          value={locale}\n          disableClearable\n          onChange={(event: any, newValue: string | null) => {\n            setLocale(newValue as SupportedLocales);\n          }}\n          renderInput={(params) => (\n            <TextField {...params} label=\"Locale\" fullWidth />\n          )}\n        />\n        <TablePagination\n          count={2000}\n          rowsPerPage={10}\n          page={1}\n          component=\"div\"\n          onPageChange={() => {}}\n        />\n      </ThemeProvider>\n    </Box>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 47,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/TablePagination",
      "@mui/material/Autocomplete",
      "@mui/material/Box",
      "@mui/material/TextField",
      "@mui/material/styles",
      "@mui/material/locale"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
